export const SET_BALANCE = 'SET_BALANCE';
export const SET_PROFIT= 'SET_PROFIT';
export const SET_USERINFO = 'SET_USERINFO';
export const SET_USER_LEVEL = 'SET_USER_LEVEL';
export const SET_NAV_TAB = 'SET_NAV_TAB';
